import "./style.css";
import User from "./user";
import Post from "./post";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { modes } from "../../utils/navLinks";
import { RxCrossCircled } from "react-icons/rx";
import { MdDeleteOutline } from "react-icons/md";
import { IoArrowBackCircle } from "react-icons/io5";
import CustomModal from "../../components/customModal";
import { deleteReportedPost, sendWarningEmail } from "./actions";
import ReportManager_Sidebar from "../../components/reportSidebar";
import { block_unblock_user } from "../users/actions";
import { IoWarningOutline } from "react-icons/io5";
import { useLocation } from "react-router-dom";

/**
 * @function ReportManager
 * @description for ReportManager
 * @returns JSX for ReportManager
 */

const ReportManager = () => {
  const location = useLocation();
  const { id = "", type = "" } = location.state || {};
  const [mode, setMode] = useState(type || modes[0].value);
  const [selectedId, setSeletedId] = useState(id);
  const [userStatus, setUserStatus] = useState(0);
  const [modal, setModal] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const dispatch = useDispatch();

  const closeModal = () => {
    setModal(false);
  };
  const closewarningModal = () => setWarningModal(false);

  const selectedIdHandler = React.useCallback((id) => {
    setSeletedId(id);
  }, []);

  const modeHandler = (nextMode) => {
    setMode(nextMode);
    setSeletedId("");
  };

  const block_unblock_handler = (_id, status) => {
    if (status === 1) {
      dispatch(
        block_unblock_user({ status: 2 }, `?userId=${_id}`, (response) => {
          if (response.isSuccess) {
            setUserStatus(2);
            setModal(false);
          }
        })
      );
    } else {
      dispatch(
        block_unblock_user({ status: 1 }, `?userId=${_id}`, (response) => {
          if (response.isSuccess) {
            setUserStatus(1);
            setModal(false);
          }
        })
      );
    }
  };
  const DeletePostHandler = (id) => {
    dispatch(
      deleteReportedPost(id, (response) => {
        if (response?.isSuccess) {
          setModal(false);
          // setSeletedId("");
        }
      })
    );
  };
  const sentWarningMailHandler = () => {
    const payload = {
      id: selectedId,
      flag: mode === "User" ? "user" : "post",
    };
    dispatch(
      sendWarningEmail(payload, (response) => {
        console.log("response :", response);
        if (response?.isSuccess) {
          setWarningModal(false);
          // setSeletedId("");
        }
      })
    );
  };
  const view = {
    User: (
      <User
        selectedUserId={selectedId}
        setUserStatus={setUserStatus}
        selectedIdHandler={selectedIdHandler}
        userStatus={userStatus}
      />
    ),
    Post: (
      <Post selectedPostId={selectedId} selectedIdHandler={selectedIdHandler} />
    ),
  };

  const renderModalBody = (message) => {
    return (
      <div>
        Are you sure want to
        <span className="highlight--text">{" " + message + " "}</span>?
      </div>
    );
  };

  const renderWarningModalBody = () => {
    return (
      <div>
        Are you sure want to send warning mail for this
        <span className="highlight--text">
          {mode === "User" ? " user " : " post "}
        </span>
        ?
      </div>
    );
  };

  return (
    <div className="report-manager-container">
      <ReportManager_Sidebar
        modeHandler={modeHandler}
        mode={mode}
        modes={modes}
      />
      <div className="report-content-container">
        <MemoizedNavbar
          mode={mode}
          selectedId={selectedId}
          userStatus={userStatus}
          setModal={setModal}
          setSeletedId={setSeletedId}
          setWarningModal={setWarningModal}
        />
        {view[mode]}
      </div>
      <CustomModal
        body={
          mode === "User"
            ? userStatus === 1
              ? () => renderModalBody("Block this user")
              : () => renderModalBody("Unblock this user")
            : () => renderModalBody("Delete this post")
        }
        confirmHandler={
          mode === "User"
            ? () => block_unblock_handler(selectedId, userStatus)
            : () => DeletePostHandler(selectedId)
        }
        heading={"Confirmation"}
        modalSize={"md"}
        visible={modal}
        visibleHandler={closeModal}
        confirmText={mode === "User" ? "Confirm" : "Yes, Delete"}
      />

      {/* warning modal */}
      <CustomModal
        body={
          mode === "User"
            ? () => renderWarningModalBody("user")
            : () => renderWarningModalBody("post")
        }
        confirmHandler={sentWarningMailHandler}
        heading={"Confirmation"}
        modalSize={"md"}
        visible={warningModal}
        visibleHandler={closewarningModal}
        confirmText={"Yes, send"}
      />
    </div>
  );
};

const MemoizedNavbar = React.memo(
  ({
    mode,
    selectedId,
    userStatus,
    setModal,
    setSeletedId,
    setWarningModal,
  }) => {
    return (
      <div className="border-bottom navbar-container-rm">
        <p className="sidebar-head-text navbar-head-text">
          {selectedId.length > 0 && (
            <IoArrowBackCircle
              className="back--arrow--icon"
              onClick={() => setSeletedId("")}
            />
          )}
          {mode + " Reports"}
        </p>
        {/* warning main button */}
        <div className="d-flex gap-5">
          {selectedId.length > 0 && mode === "User" && userStatus === 1 && (
            <div
              onClick={() => setWarningModal(true)}
              className={`site-details-btns site-warning-btn--feedback`}
            >
              Sent warning mail
              {<IoWarningOutline fontSize={"1.4rem"} />}
            </div>
          )}
          {selectedId.length > 0 && mode === "User" && (
            <div
              onClick={() => setModal(true)}
              className={`site-details-btns  ${userStatus === 2 ? "site-success-btn" : "site-warning-btn"}`}
            >
              {userStatus === 1 ? "Block User" : "Unblock User"}
              {<RxCrossCircled fontSize={"1.4rem"} />}
            </div>
          )}

          {selectedId.length > 0 && mode === "Post" && (
            <div
              onClick={() => setWarningModal(true)}
              className={`site-details-btns  site-warning-btn--feedback`}
            >
              {"Sent warning mail"}
              {<IoWarningOutline fontSize={"1.4rem"} />}
            </div>
          )}
          {selectedId.length > 0 && mode === "Post" && (
            <div
              onClick={() => setModal(true)}
              className={`site-details-btns  site-warning-btn`}
            >
              {"Delete Post"}
              {<MdDeleteOutline fontSize={"1.4rem"} />}
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default ReportManager;
